/*
 * price-manager.js — rachev
 * Single source of truth for displayed prices on the product page.
 *
 * It listens to two inputs and syncs THREE outputs together:
 *   inputs:
 *     - 'qb:state-changed'  (from quantity-breaks-engine.js)
 *     - 'variant:change' / 'variantChange' (theme variant selection, best-effort)
 *   outputs (kept in lock-step):
 *     1. main product price   .price-item.main-price + .price__compare-price
 *     2. in-button price      [class^="main-atc-price-span-"] / #main-atc-price-*
 *     3. sticky-atc price     [id^="sticky-atc-price-"] / [class^="main-atc-price-span-"]
 *
 * qb:state-changed contract (MUST match quantity-breaks-engine.js +
 * sticky-atc-bridge.js):
 *   detail.quantity, detail.qbDiscount, detail.basePrice, detail.baseComparePrice
 */
(function () {
  'use strict';

  if (window.__priceManagerInit) return;
  window.__priceManagerInit = true;

  var state = {
    quantity: 1,
    qbDiscount: 0,
    basePrice: null,        // discounted total in cents
    baseComparePrice: null  // compare-at total in cents
  };

  // Currency-aware (mirrors quantity-breaks-engine.js). The theme does NOT
  // define Shopify.formatMoney; the old fallback dropped the currency sign.
  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    if (typeof window.__rachevFormatMoney === 'function') {
      return window.__rachevFormatMoney(cents);
    }
    var w = document.querySelector('.qb-wrapper[data-currency]');
    var cur = (w && w.dataset.currency) || 'EUR';
    var loc = (w && w.dataset.locale) || 'bg';
    if (cur === 'EUR') {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
    try {
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  function setText(el, text) {
    if (!el) return;
    el.textContent = text;
    // Never let a sync hide the price (block-vanishes trap).
    el.classList.remove('hidden');
    el.style.display = el.style.display === 'none' ? '' : el.style.display;
  }

  function syncAll() {
    if (state.basePrice == null) return;

    var priceStr = formatMoney(state.basePrice);
    var hasCompare = state.baseComparePrice != null && state.baseComparePrice > state.basePrice;
    var compareStr = hasCompare ? formatMoney(state.baseComparePrice) : '';

    // 1. Main product price (regular + sale variants), skip compare nodes.
    document
      .querySelectorAll('.price-item--regular.main-price, .price-item--sale.main-price, .main-price')
      .forEach(function (el) {
        if (el.closest('.price__compare-price')) return;
        if (el.classList.contains('main-comapre-price')) return;
        setText(el, priceStr);
      });

    // 1b. Main compare price.
    document.querySelectorAll('.price__compare-price').forEach(function (wrap) {
      if (hasCompare) {
        wrap.style.display = '';
        wrap.querySelectorAll('.price-item').forEach(function (el) { el.textContent = compareStr; });
      } else {
        wrap.style.display = 'none';
      }
    });

    // 2. In-button price (main ATC) — both span-class and id forms.
    document.querySelectorAll('[class*="main-atc-price-span-"]').forEach(function (el) {
      setText(el, priceStr);
    });
    document.querySelectorAll('[id^="main-atc-price-"]').forEach(function (el) {
      setText(el, priceStr);
    });

    // 3. Sticky-atc price.
    document.querySelectorAll('[id^="sticky-atc-price-"]').forEach(function (el) {
      setText(el, priceStr);
    });
    document.querySelectorAll('[id^="sticky-atc-separate-price-"]').forEach(function (el) {
      setText(el, priceStr);
    });

    // 4. ATC compare price labels.
    document.querySelectorAll('.main-atc-compare-price').forEach(function (el) {
      if (hasCompare) {
        el.textContent = compareStr;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  // ---- Input: quantity-break selection ----
  document.addEventListener('qb:state-changed', function (e) {
    var d = e.detail || {};
    if (typeof d.quantity === 'number') state.quantity = d.quantity;
    if (typeof d.qbDiscount === 'number') state.qbDiscount = d.qbDiscount;
    if (typeof d.basePrice === 'number') state.basePrice = d.basePrice;
    if (typeof d.baseComparePrice === 'number') state.baseComparePrice = d.baseComparePrice;
    syncAll();
  });

  // ---- Input: variant change (best-effort; recompute with current tier) ----
  function onVariantChange(variant) {
    if (!variant) return;
    var unit = variant.price;
    var unitCompare = variant.compare_at_price || unit;
    var total = unit * state.quantity;
    var totalCompare = unitCompare * state.quantity;
    state.basePrice = Math.round(total - (total * state.qbDiscount) / 100);
    state.baseComparePrice = totalCompare;
    syncAll();
  }

  // Shrine / Dawn-style variant change events.
  document.addEventListener('variant:change', function (e) {
    onVariantChange((e.detail && (e.detail.variant || e.detail)) || null);
  });
  document.addEventListener('variantChange', function (e) {
    onVariantChange((e.detail && (e.detail.variant || e.detail)) || null);
  });

  window.__rachevPriceManager = {
    sync: syncAll,
    getState: function () { return Object.assign({}, state); }
  };
})();
